import { Detail } from "@dna/react";
import React from "react";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { FilterStatus } from "./resident-filter/FilterStatus";
import { makeStyles } from '@material-ui/core/styles';

const menuitemStyle = {
    backgroundColor: "#008381", color: "white", fontStyle: "Source Sans Pro"
};

const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: "Source Sans Pro",
        '&:hover': {
            backgroundColor: "#e1e1e1",
            cursor: "default",
        }
    },
}));

export default function ResidentStatus(props: {
    onResidentStatusChanged: (val: string) => void;
    state: any
}) {
    const classes = useStyles();
    const handleChange = (event: any) => {
        props.onResidentStatusChanged(event?.target?.value || '');
    };
    return (<>
        <Detail
            css={{
                color: "muted"
            }}
            level="small"
        >
            Resident status
        </Detail>
        <Select
            className={classes.root}
            labelId="resident-status-label"
            id="resident-status-select"
            value={props.state}
            onChange={handleChange}
        >
            <MenuItem className={classes.root} style={props.state == FilterStatus.Active ? menuitemStyle : {}} value={FilterStatus.Active}>Active</MenuItem>
            <MenuItem className={classes.root} style={props.state == FilterStatus.Deceased ? menuitemStyle : {}} value={FilterStatus.Deceased}>Deceased</MenuItem>
            <MenuItem className={classes.root} style={props.state == FilterStatus.Discharged ? menuitemStyle : {}} value={FilterStatus.Discharged}>Discharged</MenuItem>
        </Select></>
    );
};